export { default as ReleaseFlagsMspa } from "./ReleaseFlagsMspa";
